// extracted by mini-css-extract-plugin
export default {"review":"Home_review__hx4xU"};